<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="margin-top-bar overflow-hidden">
    <template v-if="allImages.length > 0">
      <div class="images-section">
        <template v-if="fromBuscador && hotelSeleccionadoBuscador != null">
          <div class="d-none d-md-block buscador-overlay">
            <BuscadorParaTi />
          </div>
          <div class="card buscador-ocultar shadow w-70 mx-3 d-block d-md-none buscador-overlay-mobile">
            <div class="card-body text-primary position-relative pb-0">
              <HeaderBuscadorParaTi />
              <div class="m-1 text-end mb-3 div-button-buscador-mobile">
                <button
                  class="btn btn-primary rounded-circle me-1"
                  data-bs-toggle="modal"
                  data-bs-target="#modalBuscadorParaTi">
                  <div class="d-flex">
                    <div class="">
                      <i class="fa-solid fa-magnifying-glass fa-sm" />
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </template>
        <ImageGallery :images="allImages" class="mt-15 pb-25" />
      </div>
    </template>
    <div class="alojamiento-wrapper">
      <div>
        <div class="alojamiento-container text-primary">
          <div class="my-25">
            <!-- Desktop -->
            <div class="d-none d-md-flex align-items-center mb-12">
              <span class="h4 semibold mr-20">{{ informacionAlojamiento.nombre }}</span>
              <div class="d-flex align-items-center">
                <template v-for="estrellas in informacionAlojamiento.estrellas" :key="estrellas">
                  <i class="fa-regular fa-star" width="24px" height="24px" />
                </template>
              </div>
            </div>
            <!-- Mobile -->
            <div class="d-flex d-md-none flex-column mb-10">
              <span class="h4 semibold">{{ informacionAlojamiento.nombre }}</span>
            </div>
            <div class="d-flex d-md-none align-items-center mb-10">
              <template v-for="estrellas in informacionAlojamiento.estrellas" :key="estrellas">
                <i class="fa-regular fa-star" width="24px" height="24px" />
              </template>
            </div>
            <!-- Desktop -->
            <div class="d-none d-md-flex align-items-center mb-30 flex-wrap">
              <CustomIcon :icon="locationIcon" class="text-primary me-2" size="14px" />
              <span class="p me-2">{{ informacionAlojamiento.ubicacion }}</span>
              <button class="btn btn-link p-0 text-decoration-underline small" @click="modalMapaRef?.show()">
                {{ $t('alojamiento.verMapa') }}
              </button>
              <span class="separator mx-30" />
              <template v-if="informacionAlojamiento.checkIn">
                <CustomIcon :icon="checkinIcon" class="text-primary me-2" size="16px" />
                <span class="me-1 semibold">{{ $t('alojamiento.checkIn') }}</span>
                <span class="translate">{{ $t('alojamiento.aPartirDeLas') }} {{ informacionAlojamiento.checkIn }}</span>
              </template>
              <span class="separator mx-30" />
              <template v-if="informacionAlojamiento.checkOut">
                <CustomIcon :icon="checkoutIcon" class="text-primary me-2" size="16px" />
                <span class="me-1 semibold">{{ $t('alojamiento.checkOut') }}</span>
                <span class="translate"
                  >{{ $t('alojamiento.aPartirDeLas') }} {{ informacionAlojamiento.checkOut }}</span
                >
              </template>
            </div>
            <!-- Mobile -->
            <div class="d-flex d-md-none align-items-center mb-15">
              <CustomIcon :icon="locationIcon" class="text-primary me-2" size="14px" />
              <span class="p me-2">{{ informacionAlojamiento.ubicacion }}</span>
              <button class="btn btn-link p-0 text-decoration-underline small" @click="modalMapaRef?.show()">
                {{ $t('alojamiento.verMapa') }}
              </button>
            </div>
            <!-- Mobile -->
            <div
              v-if="informacionAlojamiento.checkIn || informacionAlojamiento.checkOut"
              class="d-flex d-md-none checkin-checkout-mobile mb-25">
              <template v-if="informacionAlojamiento.checkIn">
                <div class="checkin-block">
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <CustomIcon :icon="checkinIcon" class="text-primary me-2" size="16px" />
                      <span class="semibold">{{ $t('alojamiento.checkIn') }}</span>
                    </div>
                    <span class="ms-2 small translate"
                      >{{ $t('alojamiento.aPartirDeLas') }} {{ informacionAlojamiento.checkIn }}</span
                    >
                  </div>
                </div>
              </template>
              <span
                v-if="informacionAlojamiento.checkIn && informacionAlojamiento.checkOut"
                class="separator-vertical"></span>
              <template v-if="informacionAlojamiento.checkOut">
                <div class="checkout-block">
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <CustomIcon :icon="checkoutIcon" class="text-primary me-2" size="16px" />
                      <span class="semibold">{{ $t('alojamiento.checkOut') }}</span>
                    </div>
                    <span class="ms-2 small translate"
                      >{{ $t('alojamiento.aPartirDeLas') }} {{ informacionAlojamiento.checkOut }}</span
                    >
                  </div>
                </div>
              </template>
            </div>
            <div class="mb-25 translate">
              <div v-sanitize-html="formattedInfo" class="p text-primary text-justify"></div>
            </div>
          </div>

          <template v-if="informacionAlojamiento?.servicios?.length > 0">
            <div class="pt-25 pt-m-20 mb-25 mb-m-20">
              <span class="h5 semibold mb-25 d-block">
                {{ $t('alojamiento.servicioHotel') }}
              </span>
              <div class="row g-10 g-m-10">
                <div v-for="(servicio, index) in informacionAlojamiento.servicios" :key="index" class="col-12 col-md-3">
                  <div class="servicio-card tooltip-container p-m-10">
                    <div class="d-flex align-items-center">
                      <div class="icon-circle icon-circle-servicio flex-shrink-0">
                        <CustomIcon :icon="checkIcon" class="text-primary" size="20px" />
                      </div>
                      <div class="ms-3 flex-grow-1 overflow-hidden">
                        <div class="medium p text-truncate text-primary servicio-name translate">
                          {{ capitalizeFirstLetter(servicio) }}
                        </div>
                      </div>
                    </div>
                    <div class="tooltip-text-servicio">
                      <div class="servicio-tooltip-content">
                        <span class="translate">{{ capitalizeFirstLetter(servicio) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template
            v-if="
              informacionAlojamiento?.accesosPistas?.length > 0 || informacionAlojamiento?.puntosinteres?.length > 0
            ">
            <div class="pt-25 pt-m-20 mb-25 mb-m-20">
              <span class="h5 semibold mb-25 d-block">
                <span class="translate">{{ $t('alojamiento.puntoInteres') }}</span>
              </span>
              <div class="row g-10 g-m-10">
                <template v-if="informacionAlojamiento?.accesosPistas?.length > 0">
                  <div
                    v-for="(acceso, index) in informacionAlojamiento.accesosPistas"
                    :key="index"
                    class="col-12 col-md-3">
                    <div class="punto-interes-card">
                      <div class="d-flex align-items-center">
                        <div class="icon-circle icon-circle-punto flex-shrink-0">
                          <CustomIcon :icon="locationIcon" class="text-primary" size="20px" />
                        </div>
                        <div class="ms-3 flex-grow-1 overflow-hidden">
                          <div class="medium p text-truncate text-primary punto-nombre">
                            {{ acceso.nombre }}
                          </div>
                          <div class="small text-primary punto-distancia">{{ acceso.distancia + KM_ABREVIATION }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="informacionAlojamiento?.puntosinteres?.length > 0">
                  <div
                    v-for="(punto, index) in informacionAlojamiento.puntosinteres"
                    :key="index"
                    class="col-12 col-md-3">
                    <div class="punto-interes-card">
                      <div class="d-flex align-items-center">
                        <div class="icon-circle icon-circle-punto flex-shrink-0">
                          <CustomIcon :icon="locationIcon" class="text-primary" size="20px" />
                        </div>
                        <div class="ms-3 flex-grow-1 overflow-hidden">
                          <div class="medium p text-truncate text-primary punto-nombre">
                            {{ punto.nombre }}
                          </div>
                          <div class="small text-primary punto-distancia">{{ punto.distancia + KM_ABREVIATION }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div v-if="fromBuscador && hotelSeleccionadoBuscador != null" id="ofertas" class="translate">
            <h6 class="h6 bold my-3">
              {{ $t('alojamiento.regimenDisponibles') }} |
              <span class="fw-normal">
                {{ formatDateWithWeekDay(fechasAlojamiento[0]) }}
                -
                {{ formatDateWithWeekDay(fechasAlojamiento[1]) }}
              </span>
            </h6>
            <div class="d-flex gap-2 me-3 mt-4 flex-wrap">
              <div
                v-for="(lugaresExperiencia, pension) in hotelSeleccionadoBuscador.pensiones"
                :key="pension"
                class="boton-cuadro-azul translate"
                :class="hotelSeleccionadoBuscador.currentPension == pension ? 'boton-cuadro-azul-selected' : ''"
                @click="updateOpcionesPensionActual(pension)">
                {{ opcionesPension[pension] }}
              </div>
            </div>
            <template v-for="(lugaresExperiencia, pension) in hotelSeleccionadoBuscador.pensiones" :key="pension">
              <!-- Pension actual -->
              <template v-if="hotelSeleccionadoBuscador.currentPension == pension">
                <template v-for="(opciones, lugarExperiencia) in lugaresExperiencia" :key="lugarExperiencia">
                  <div
                    v-if="estacionSeleccionadaBuscador == lugarExperiencia"
                    class="d-flex flex-column cuadro-forfaits my-3 p-2 p-md-4">
                    <div class="d-flex flex-column flex-lg-row w-100 justify-content-between mb-3">
                      <div class="d-flex gap-2">
                        <div>
                          <img
                            class="img-lugarExperiencia"
                            :src="
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].imagen
                                : ''
                            "
                            alt="" />
                        </div>
                        <div class="texto-estacion">
                          <p class="mb-0 bold">
                            {{
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].nombre
                                : ''
                            }}
                          </p>
                          <div
                            v-if="
                              agenciaStore.buscadorForfaitEnabled &&
                              hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                            "
                            class="d-flex align-items-start gap-1 ms-0">
                            <img class="icono-distancia-estacion" src="@/assets/icons/icono-telesilla.webp" />
                            <span class="texto-distancia-estacion">
                              {{ $t('general.a') }}
                              {{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .distanciaKM >= 1
                                  ? hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM + KM_ABREVIATION
                                  : hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM *
                                      1000 +
                                    M_ABREVIATION
                              }}
                              {{ $t('alojamiento.deEstacionEsqui') }}({{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .nombreAccesoPista
                              }})
                            </span>
                          </div>
                        </div>
                      </div>

                      <template v-if="desplegarEstaciones[lugarExperiencia] !== undefined">
                        <!-- Icono up y down -->
                        <i
                          v-if="desplegarEstaciones[lugarExperiencia]"
                          class="cursor-pointer ms-5 me-3 h4 fa-solid fa-angle-up d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                        <i
                          v-else
                          class="cursor-pointer ms-5 me-3 h4 fa-solid fa-angle-down d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                      </template>
                    </div>
                    <template
                      v-if="
                        desplegarEstaciones[lugarExperiencia] !== undefined &&
                        desplegarEstaciones[lugarExperiencia] &&
                        numOpcionesMostrar[lugarExperiencia] !== undefined
                      ">
                      <div
                        v-for="(opcion, indOpcion) in opciones.slice(0, numOpcionesMostrar[lugarExperiencia])"
                        :key="indOpcion"
                        class="d-flex flex-column flex-md-row cuadro-opcion my-2 justify-content-between p-4">
                        <div class="d-flex flex-column gap-4 informacion-habitaciones">
                          <template v-for="(habitacion, indHab) in opcion.combinacion" :key="indHab">
                            <p class="bold mb-0">
                              {{ $t('general.habitacion') }}
                              {{ titleCase(habitacion.texto) }}
                            </p>
                            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                              <div class="ms-4 d-flex w-100 translate">
                                <div v-for="i in habitacion.precios.personas.numAdultos" :key="i" class="personas">
                                  <img src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                <div
                                  v-for="i in habitacion.precios.personas.numNinios"
                                  :key="i"
                                  class="personas d-flex">
                                  <img class="personitas" src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                {{ formatMiembrosHabitacion(habitacion.precios.personas) }}
                              </div>
                              <div class="d-flex flex-column text-start text-sm-end w-100">
                                <p v-if="habitacion.precios.personas.numAdultos > 0" class="m-0">
                                  {{ $t('general.personas.mayus.adulto') }}:
                                  <span class="bold">
                                    {{ habitacion.precios.personas.precioAdulto }}{{ agenciaStore.getCurrency }}
                                  </span>
                                </p>
                                <p v-for="(n, i) in habitacion.precios.personas.ninios" :key="i" class="m-0">
                                  {{ $t('general.personas.mayus.nino') }}
                                  {{ n.edad }}
                                  {{ $t('general.anios') }}:
                                  <span class="bold">{{ n.precio }}{{ agenciaStore.getCurrency }}</span>
                                </p>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="d-flex flex-column align-items-end justify-content-between">
                          <div
                            v-if="opcion.tipoCancelacion == 'TOTAL'"
                            class="texto-cancelacion-total bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.cancelacionGratis') }}
                          </div>
                          <div
                            v-else-if="opcion.tipoCancelacion == 'PARCIAL'"
                            class="texto-cancelacion-parcial bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.parcialmenteReembolsable') }}
                          </div>
                          <div v-else />
                          <div class="d-flex flex-column justify-content-end gap-2 alignt-items-center">
                            <p class="d-flex align-items-center gap-2 texto-desde-precio m-0 justify-content-end">
                              {{ $t('subtitulo.total') }}:
                              <span class="h6 bold">
                                {{ opcion.precioTotalReserva }}{{ agenciaStore.getCurrency }}
                              </span>
                            </p>
                            <div class="w-100 text-end">
                              <button
                                class="boton boton-naranja bold ms-0"
                                @click="saveCombinacion(opcion, lugarExperiencia)">
                                {{ $t('general.reservar') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end align-content-center mt-2 mb-1 me-2 gap-3">
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] > 2
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, false)">
                          {{ $t('general.mostrarMenos') }}
                        </div>
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] < opciones?.length
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, true)">
                          {{ $t('general.mostrarMas') }}
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <h6
                  v-if="
                    Object.keys(lugaresExperiencia).filter(e => {
                      return e != estacionSeleccionadaBuscador;
                    })?.length > 0
                  "
                  class="h6 bold my-4 mb-3">
                  {{ $t('alojamiento.otrasOpcionesViaje') }}
                </h6>
                <template v-for="(opciones, lugarExperiencia) in lugaresExperiencia" :key="lugarExperiencia">
                  <div
                    v-if="estacionSeleccionadaBuscador != lugarExperiencia"
                    class="d-flex flex-column cuadro-forfaits my-3 p-2 p-md-4">
                    <div class="d-flex flex-column flex-md-row w-100 justify-content-between mb-3">
                      <div class="d-flex gap-2">
                        <div>
                          <img
                            class="img-estacion"
                            :src="
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].imagen
                                : ''
                            "
                            alt="" />
                        </div>

                        <div class="texto-estacion">
                          <p class="mb-0 bold">
                            {{
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].nombre
                                : ''
                            }}
                          </p>
                          <div
                            v-if="hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]"
                            class="d-flex align-items-start gap-1 ms-0">
                            <img class="icono-distancia-estacion" src="@/assets/icons/icono-telesilla.webp" />
                            <span class="texto-distancia-estacion">
                              a
                              {{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .distanciaKM >= 1
                                  ? hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM + KM_ABREVIATION
                                  : hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM *
                                      1000 +
                                    M_ABREVIATION
                              }}
                              {{ $t('alojamiento.deEstacionEsqui') }}({{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .nombreAccesoPista
                              }})
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="info-estacion">
                        {{
                          estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                            ? estacionesData[lugarExperiencia].texto
                            : ''
                        }}
                      </div>
                      <template v-if="desplegarEstaciones[lugarExperiencia] !== undefined">
                        <i
                          v-if="desplegarEstaciones[lugarExperiencia]"
                          class="cursor-pointer ms-5 me-3 h4 fa-solid fa-angle-up d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                        <i
                          v-else
                          class="cursor-pointer ms-5 me-3 h4 fa-solid fa-angle-down d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                      </template>
                    </div>

                    <template
                      v-if="
                        desplegarEstaciones[lugarExperiencia] !== undefined &&
                        desplegarEstaciones[lugarExperiencia] &&
                        numOpcionesMostrar[lugarExperiencia] !== undefined
                      ">
                      <div
                        v-for="(opcion, indOpcion) in opciones.slice(0, numOpcionesMostrar[lugarExperiencia])"
                        :key="indOpcion"
                        class="d-flex flex-column flex-md-row cuadro-opcion my-2 justify-content-between p-4">
                        <div class="d-flex flex-column gap-4 informacion-habitaciones">
                          <template v-for="(habitacion, indHab) in opcion.combinacion" :key="indHab">
                            <p class="bold mb-0">
                              {{ $t('general.habitacion') }}
                              {{ titleCase(habitacion.texto) }}
                            </p>
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                              <div class="ms-4 d-flex w-100">
                                <div v-for="i in habitacion.precios.personas.numAdultos" :key="i" class="personas">
                                  <img src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                <div
                                  v-for="i in habitacion.precios.personas.numNinios"
                                  :key="i"
                                  class="personas d-flex">
                                  <img class="personitas" src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                {{ formatMiembrosHabitacion(habitacion.precios.personas) }}
                              </div>
                              <div class="d-flex flex-column text-start text-md-end w-100">
                                <p v-if="habitacion.precios.personas.numAdultos > 0" class="m-0">
                                  {{ $t('general.personas.mayus.adulto') }}:
                                  <span class="bold">
                                    {{ formatPrice(habitacion.precios.personas.precioAdulto)
                                    }}{{ agenciaStore.getCurrency }}
                                  </span>
                                </p>
                                <p v-for="(n, i) in habitacion.precios.personas.ninios" :key="i" class="m-0">
                                  {{ $t('general.personas.mayus.nino') }}
                                  {{ n.edad }}
                                  {{ $t('general.anios') }}:
                                  <span class="bold"> {{ formatPrice(n.precio) }}{{ agenciaStore.getCurrency }} </span>
                                </p>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="d-flex flex-column align-items-end justify-content-between">
                          <div
                            v-if="opcion.tipoCancelacion == 'TOTAL'"
                            class="texto-cancelacion-total bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.cancelacionGratis') }}
                          </div>
                          <div
                            v-else-if="opcion.tipoCancelacion == 'PARCIAL'"
                            class="texto-cancelacion-parcial bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.parcialmenteReembolsable') }}
                          </div>
                          <div v-else />
                          <div class="d-flex flex-column justify-content-end gap-2 alignt-items-center">
                            <p class="d-flex align-items-center gap-2 texto-desde-precio m-0 justify-content-end">
                              {{ $t('subtitulo.total') }}:
                              <span class="h6 bold">
                                {{ opcion.precioTotalReserva }}{{ agenciaStore.getCurrency }}
                              </span>
                            </p>
                            <div class="w-100 text-end">
                              <button
                                class="boton boton-naranja bold ms-0"
                                @click="saveCombinacion(opcion, lugarExperiencia)">
                                {{ $t('general.reservar') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end align-content-center mt-2 mb-1 me-2 gap-3">
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] > 2
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, false)">
                          {{ $t('general.mostrarMenos') }}
                        </div>
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] < opciones?.length
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, true)">
                          {{ $t('general.mostrarMas') }}
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </template>
            </template>
          </div>
          <div v-if="informacionAlojamiento?.faqs?.length > 0" class="pt-25 pt-m-20 mb-25 mb-m-20">
            <span id="preguntas" class="h5 semibold mb-25 d-block">
              {{ $t('alojamiento.preguntasFrecuentes') }}
            </span>
            <PreguntasRespuestas :faqs="informacionAlojamiento.faqs" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalMapa
    ref="modalMapaRef"
    :latitud="informacionAlojamiento.latitud"
    :longitud="informacionAlojamiento.longitud"
    :nombre="informacionAlojamiento.nombre" />

  <ModalBuscador v-if="fromBuscador" />

  <ModalSimple id-modal="modalBuscadorParaTi" aria-labelled-by="modalBuscadorLabel">
    <template #titulo>
      <div class="bold texto-nuestros-viajes-modal">{{ $t('alojamiento.modales.buscador.titulo') }}</div>
    </template>
    <template #contenido>
      <BuscadorParaTi />
    </template>
  </ModalSimple>

  <ModalSimple id-modal="modalFiltro" aria-labelled-by="modalFiltroLabel">
    <template #titulo>
      <div class="bold texto-nuestros-viajes-modal">{{ $t('alojamiento.modales.filtros.titulo') }}</div>
    </template>
    <template #contenido>
      <div class="filtros">
        <div class="d-flex justify-content-between align-items-center">
          <div class="cuadro-azul">{{ $t('alojamiento.modales.filtros.subtitulo') }}</div>
          <button class="boton boton-no-fondo p-1" @click="resetFiltros()">
            {{ $t('alojamiento.modales.filtros.reestablecer') }}
          </button>
        </div>
      </div>
    </template>
  </ModalSimple>
</template>

<script setup>
  import { ref, computed, watch, onBeforeMount } from 'vue';
  import { buscadorStore } from '@/store_pinia/buscador';
  import { titleCase, capitalizeFirstLetter } from '@/helpers/filters';
  import { formatDateWithWeekDay } from '@/helpers/dateUtiles';
  import { BuscadorServicios } from '@/router/RouterNames';
  import BuscadorParaTi from '@/components/buscadores/BuscadorParaTi.vue';
  import router from 'src/router';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import HeaderBuscadorParaTi from '@/components/header/headerBuscadorParaTi';
  import ModalSimple from '@/components/modales/ModalSimple.vue';
  import ModalMapa from '@/components/modales/ModalMapa.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { usePageMeta } from '@/composables/usePageMeta';
  import HomeApiService from '@/services/api/HomeApiService';
  import { useRoute } from 'vue-router';
  import { formatPrice } from '@/helpers/numberUtils';
  import ImageGallery from '@/components/ImageGallery.vue';
  import { sortResourcesByOrden } from '@/helpers/resourceUtils';
  import CustomIcon from '@/components/CustomIcon.vue';
  import locationIcon from '@/assets/icons/ubicacion.svg';
  import checkinIcon from '@/assets/icons/checkin.svg';
  import checkoutIcon from '@/assets/icons/checkout.svg';
  import checkIcon from '@/assets/icons/check.svg';
  import { KM_ABREVIATION, M_ABREVIATION } from '@/constants/generalConstants';
  import PreguntasRespuestas from '@/components/common/PreguntasRespuestas.vue';

  const route = useRoute();
  const loadingStore = useLoadingStore();
  const store_buscador = buscadorStore();
  const agenciaStore = agenciaStoreModule();
  const opcionesPension = store_buscador.opcionesPension;
  const estacionesData = ref({});
  const numOpcionesMostrar = ref({});
  const desplegarEstaciones = ref({});
  const fromBuscador = route.path.includes('buscador');

  const initializing = ref(true);
  const informacionAlojamiento = ref({});
  const modalMapaRef = ref(null);
  const { webPageSchema } = usePageMeta({
    title: computed(() => informacionAlojamiento.value?.tituloSeo),
    description: computed(() => informacionAlojamiento.value?.descripcionSeo),
    image: computed(() => informacionAlojamiento.value?.imagenPrincipal),
  });

  const filtrosBuscador = computed(() => store_buscador.filtrosBuscador);
  const estacionSeleccionadaBuscador = computed(() => store_buscador.estacionSeleccionada);
  const hotelSeleccionadoBuscador = computed(() => store_buscador.hotelSeleccionado);
  const fechasAlojamiento = computed(() => store_buscador.filtrosSeleccionadosBuscador.fechasAlojamiento);

  const formattedInfo = computed(() => {
    return informacionAlojamiento.value?.info || '';
  });

  const allImages = computed(() => {
    const images = [];
    if (informacionAlojamiento.value?.imagenPrincipal?.url) {
      images.push(informacionAlojamiento.value.imagenPrincipal);
    }
    if (informacionAlojamiento.value?.imagenesSecundarias?.length > 0) {
      images.push(...informacionAlojamiento.value.imagenesSecundarias);
    }
    return sortResourcesByOrden(images);
  });

  function updateOpcionesPensionActual(optKey) {
    store_buscador.hotelSeleccionado.currentPension = optKey;
  }

  function scrollToElement(element) {
    window.scrollTo({
      top: document.getElementById(element)?.offsetTop - document.getElementById('desktop-navbar')?.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  function formatMiembrosHabitacion(personas) {
    let textAdulto =
      personas.numAdultos == 0
        ? null
        : personas.numAdultos == 1
        ? `${personas.numAdultos} adulto`
        : `${personas.numAdultos} adultos`;

    let textNinio =
      personas.numNinios == 0
        ? null
        : personas.numNinios == 1
        ? `${personas.numNinios} niño`
        : `${personas.numNinios} niños`;

    return textAdulto && textNinio ? `${textAdulto} + ${textNinio}` : textAdulto ? textAdulto : textNinio;
  }

  function mostrarOpciones(lugarExperiencia, mas) {
    if (mas) numOpcionesMostrar.value[lugarExperiencia] += 2;
    else numOpcionesMostrar.value[lugarExperiencia] -= 2;
  }

  function saveCombinacion(combinacion, lugarExperiencia) {
    store_buscador.setCombinacion(combinacion);
    store_buscador.setEstacionOpcionSeleccionada(lugarExperiencia);
    router.push({ name: BuscadorServicios });
  }

  async function init() {
    try {
      loadingStore.show();
      informacionAlojamiento.value = await HomeApiService.getAlojamiento(route.params.idAlojamiento);

      if (fromBuscador) {
        setTimeout(() => {
          scrollToElement('ofertas');
        }, 200);
      }
    } catch (error) {
      console.error(error);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  watch(
    filtrosBuscador,
    () => {
      let lugaresExperiencia = {};
      let opciones = {};
      let desplegar = {};

      if (filtrosBuscador.value != null) {
        filtrosBuscador.value.areas.forEach(ar => {
          ar.lugaresExperiencia.forEach(est => {
            lugaresExperiencia[est.id] = {
              imagen: est.icono,
              nombre: est.nombre,
              texto: est.descripcion,
            };

            opciones[est.id] = 2;

            desplegar[est.id] = est.id == estacionSeleccionadaBuscador.value;
          });
        });

        estacionesData.value = lugaresExperiencia;
        numOpcionesMostrar.value = opciones;
        desplegarEstaciones.value = desplegar;
      }

      return lugaresExperiencia;
    },
    { immediate: true }
  );

  onBeforeMount(async () => await init());
</script>

<style lang="scss" scoped>
  .botones-container {
    padding: 1rem;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .btn-primary {
    border-radius: var(--bs-border-radius-xl);
    margin-right: 10px;
  }

  h5,
  h4,
  h6 {
    color: rgba(var(--bs-primary-rgb), 0.75);
  }

  .margin-top-bar {
    margin-top: 100px;

    @media (max-width: 768px) {
      margin-top: 78px;
    }
  }

  .alojamiento-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .images-section {
    position: relative;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .buscador-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 20px;
  }

  .buscador-overlay-mobile {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }

  .separator {
    width: 1px;
    height: 20px;
    background-color: rgba(var(--bs-primary-rgb), 0.2);
    margin: 0 30px;
  }

  .separator-vertical {
    width: 1px;
    min-height: 40px;
    background-color: rgba(var(--bs-primary-rgb), 0.2);
    margin-right: 20px !important;
    flex-shrink: 0;
  }

  .checkin-checkout-mobile {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 0;
  }

  .checkin-block,
  .checkout-block {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    min-width: 0;
  }

  .servicio-card {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: 12px;
    padding: 12px;
    width: 100%;
    position: relative;

    @media (max-width: 768px) {
      padding: 10px;
    }
  }

  .punto-interes-card {
    width: 100%;
    position: relative;
  }

  .icon-circle-punto {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--bs-secondary-rgb), 0.2);
  }

  .punto-nombre {
    margin-bottom: 4px;
  }

  .punto-distancia {
    font-weight: 400;
  }

  .div-button-buscador-mobile {
    right: 0;
    bottom: -17px;
  }

  .alojamiento-container {
    width: 100%;
  }

  .tooltip-container {
    &:hover .tooltip-text-servicio {
      visibility: visible;
      opacity: 1;
      transition-delay: 0.3s;
    }
  }

  .tooltip-text-servicio {
    visibility: hidden;
    width: max-content;
    max-width: 300px;
    min-width: 150px;
    opacity: 0;
    background-color: rgba(var(--blue-1-rgb), 1);
    box-shadow: 0px 1px 2px 0px rgba(var(--blue-1-rgb), 0.35);
    color: white;
    border-radius: 8px;
    padding: 10px 12px;
    position: absolute;
    z-index: 10;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.2s ease-in-out 0.3s, visibility 0s linear 0.3s;
    font-size: 13px;
    font-weight: 400;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: rgba(var(--blue-1-rgb), 0.9) transparent transparent transparent;
    }
  }

  .servicio-tooltip-content {
    white-space: normal;
    word-wrap: break-word;
  }

  .icon-circle-servicio {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    background-color: rgba(var(--bs-secondary-rgb), 0.2);
  }

  .icono-distancia-estacion {
    width: 20px;
    margin-right: 0.05rem;
  }

  .boton {
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 500;
    padding: 0.5rem 1.5rem;
    margin-left: 1rem;
    border-radius: var(--bs-border-radius-xxl);
    transition: all 0.2s ease;
    border: 0;
  }

  .boton-no-fondo {
    background-color: inherit;
    color: var(--bs-primary);
  }

  .boton-no-fondo:hover {
    text-decoration: underline;
  }

  .boton-no-fondo:active {
    color: #080a1d;
  }

  .boton-naranja {
    background-color: var(--bs-secondary);
    color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    max-width: 110px;
  }

  @media (max-width: 768px) {
    .boton-naranja {
      width: 100%;
    }
  }

  .boton-naranja:hover {
    transform: scale(1.1);
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
  }

  .boton-naranja:active {
    outline: 2px solid rgba(33, 36, 68, 0.5);
  }

  .boton-blanco {
    background-color: white;
    color: #080a1d;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    max-width: 110px;
    min-height: 54px;
  }

  .boton-blanco:hover {
    transform: scale(1.1);
  }

  .boton-blanco:active {
    outline: 2px solid rgba(33, 36, 68, 0.5);
  }

  .cuadro-forfaits {
    border-radius: var(--bs-border-radius-xxl);
    width: 100%;
    background-color: #f9f7f8;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 768px) {
    .cuadro-forfaits {
      border-radius: var(--bs-border-radius-lg);
    }
  }

  .boton-cuadro-azul {
    border: solid 1.5px var(--bs-primary);
    border-radius: var(--bs-border-radius);
    color: var(--bs-primary);
    background-color: inherit;
    padding: 0.2rem 1.2rem;
    cursor: pointer;
    box-shadow: 1px -0.5px 2px 0 rgba(0, 0, 0, 0.4);
  }

  .boton-cuadro-azul-selected {
    background-color: var(--bs-primary);
    color: white;
  }

  .img-estacion {
    width: 30px;
  }

  .texto-estacion {
    padding-top: 0.2rem;
    padding-right: 2rem;
  }

  .info-estacion {
    color: #6f6e8e;
    font-weight: 600;
    font-size: 0.9rem;
  }

  .icono-distancia-estacion {
    width: 20px;
  }

  .texto-distancia-estacion {
    color: #0073a4;
    font-size: 0.85rem;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cuadro-opcion {
    background-color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: var(--bs-border-radius-xxl);
  }

  @media (max-width: 768px) {
    .cuadro-opcion {
      border-radius: var(--bs-border-radius-lg);
    }
  }

  .texto-desde-precio {
    font-size: 0.6rem;
  }

  .personas {
    margin-left: -13px;
  }

  .personitas {
    margin-top: 5.5px;
    margin-left: 2px;
    width: 1.1rem;
  }

  .texto-cancelacion-total {
    color: #16ab0c;
    font-size: 0.8rem;
  }

  .texto-cancelacion-parcial {
    font-size: 0.8rem;
  }

  .boton-mostrar {
    cursor: pointer;
  }

  .boton-mostrar:hover {
    text-decoration: underline;
  }

  .card-check {
    background-color: #f9f7f8;
    padding: 1.3rem 0.5rem;
    border-radius: var(--bs-border-radius-xl);
    box-shadow: 0 4px 2px -2px gray;
  }

  div :deep(.gm-ui-hover-effect) {
    display: none !important;
  }

  @media (max-width: 768px) {
    .text-container {
      display: flex;
      flex-direction: column;

      .left,
      .right {
        width: 100%;
      }
    }
  }

  .informacion-habitaciones {
    width: 50%;
  }

  @media (max-width: 768px) {
    .informacion-habitaciones {
      width: 100%;
    }
  }

  .modal-dialog {
    max-width: 750px !important;
  }

  .fa-door-open {
    opacity: 0.75;
  }

  .icon-checkin {
    transform: scaleX(-1);
  }

  .filtro-buscador {
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 100;
    font-size: 0.7rem;
  }

  .buscador-ocultar {
    border-radius: var(--bs-border-radius-xl);
  }

  @media (max-width: 768px) {
    .buscador-desktop {
      height: 0px;
      overflow: hidden;
    }
  }

  .filtro-buscador {
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 100;
    font-size: 0.7rem;
  }

  .boton-no-fondo {
    background-color: inherit;
    color: var(--bs-primary);
  }

  .cuadro-azul {
    background-color: var(--bs-primary);
    color: white;
    padding: 0.5rem 1.4rem;
    font-size: 0.9rem;
    font-weight: 650;
    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
    box-shadow: 2px -1px 5px 0 rgba(0, 0, 0, 0.5);
  }

  .icon-location {
    font-size: 0.8rem;
    color: red;
  }
</style>
